<template>
    <div class="empty" v-if="show" :style="{ height: emptyHeight + 'px' }">
        <img class="emptyImg" :src="imageSrc" alt="" />
        <p class="emptyText">{{ text }}</p>
    </div>
</template>
  
<script>
export default {
    name: 'EmptyState',
    props: {
        emptyHeight: {
            type: Number,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        },
        imageSrc: {
            type: String,
            default: require('@/assets/images/common/commonNoContent.png')
        }
    }
}
</script>
  
<style scoped>
.empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.emptyImg {
    width: 120px;
    height: 120px;
    object-fit: cover;
}

.emptyText {
    margin-top: 4px;
    font-size: 14px;
    color: #E5E5E5;
    line-height: 20px;
    text-align: center;
}
</style>